import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import SupplierGroupForm from "components/SupplierGroups/form";
import AdminBar from "components/Masterbar/AdminBar";
import { addSupplierGroup } from "redux/slices/supplierGroupsSlice";

const currentAction = "ADD";
const AddSupplierGroup = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onSubmit = async (payload) => {
    await dispatch(addSupplierGroup(payload)).then((res) =>
      res !== undefined ? history.push(PATHS.admin.supplierGroups) : ""
    );
  };

  return (
    <>
      <Navbar />
      <LightLayout doublebar>
        <SupplierGroupForm action={currentAction} onSubmit={onSubmit}/>
      </LightLayout>
    </>
  );
};

export default AddSupplierGroup;
